<template>
	<div class="container mx-auto px-4 pb-16 md:pb-48">
		<div class="flex flex-wrap">
			<div class="text-left pt-12">
				<h2 class="text-white font-semibold text-3xl pb-4">{{ getText('title1') }}</h2>
				<h3 class="text-white text-md pb-4">
					{{ this.getText('subtitle1') }}
				</h3>

				<p class="text-white text-xl w-12/12 lg:w-8/12 xxl:w-6/12 mb-4">
					{{ this.getText('actual-experience-desc') }}
				</p>

				<p class="text-white text-xl w-12/12 lg:w-8/12 xxl:w-6/12 mb-4">
					{{ this.getText('solutions-description') }}
				</p>

				<p class="text-white font-semibold text-xl py-4">{{ getText('about-experience') }}:</p>

				<div v-for="workplace in workplaceData" :key="workplace.place" class="pb-16">
					<div class="block pb-4">
						<i class="fas fa-chevron-right text-white pr-4"></i>
						<span class="text-white font-semibold text-xl pb-4">{{ getText(workplace.place) }}</span>
					</div>

					<div class="grid grid-cols-6 pb-2">
						<span class="col-span-2 text-white font-semibold">{{ getText('about-period') }}:</span>
						<span class="col-span-4 text-white font-semibold pl-4 md:pl-16 text-sm md:text-base">{{ getText(workplace.period) }}</span>
					</div>
					<div class="grid grid-cols-6 pb-2">
						<span class="col-span-2 text-white font-semibold">{{ getText('about-address') }}:</span>
						<span class="col-span-4 text-white font-semibold pl-4 md:pl-16 text-sm md:text-base">{{ getText(workplace.address) }}</span>
					</div>
					<div class="grid grid-cols-6 pb-2">
						<span class="col-span-2 text-white font-semibold">{{ getText('about-position') }}:</span>
						<span class="col-span-4 text-white font-semibold pl-4 md:pl-16 text-sm md:text-base">{{ getText(workplace.position) }}</span>
					</div>
					<div class="grid grid-cols-6 pb-2">
						<span class="col-span-2 text-white font-semibold">{{ getText('about-duties') }}:</span>
						<span class="col-span-4 text-white font-semibold pl-4 md:pl-16 text-sm md:text-base">{{ getText(workplace.duties) }}</span>
					</div>
					<div class="grid grid-cols-6 pb-2" v-if="workplace.significant">
						<span class="col-span-12 md:col-span-2 text-white font-semibold">{{ getText('about-significant') }}:</span>
						<div class="col-span-12 md:col-span-4">
							<div :class="{'pt-4': index !== 0}" v-for="(project, index) in workplace.significant" :key="project.name">
								<div class="text-white font-semibold md:pl-16 flex pt-4 md:pt-0">
									<div class="hidden md:inline-block">
										<i class="fas fa-map-marker-alt pr-2 pt-1"></i>
									</div>
									<span class="ml-2 inline-block">{{ getText(project.name) }}</span>
								</div>
								<p v-if="project.location" class="text-white text-sm md:pl-24 pt-2 ml-2">
									{{ getText('location') }}: {{ getText(project.location) }}
								</p>
								<p v-if="project.client" class="text-white text-sm md:pl-24 pt-2 ml-2">
									{{ getText('client') }}: {{ getText(project.client) }}
								</p>
								<p v-if="project.title" class="text-white text-sm md:pl-24 pt-2 ml-2">
									{{ getText(project.title) }}
								</p>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";
	import workplaceData from '../data/workplaceData';

	export default {
		name: "workplace-experience",
		data() {
			return {
				workplaceData,
			}
		},
		computed: {
			...mapGetters(['getText']),
		},
	}
</script>